// Legacy color map — now sourced entirely from the centralised brand tokens.
// No hex literals live here; every value references ./brandTokens so the palette
// is configurable in one place. `ColorsEnum.<key>` access is unchanged for callers.
import { ramps, semantic, roles, chartPalette } from './brandTokens';

export { hexToRGBA } from './brandTokens';

const { primary, accent, neutral } = ramps;

export const ColorsEnum = {
  // brand
  primary: primary[500],
  secondary: accent[500],
  beer: primary[500],
  beer18: primary[500],
  royalBlue: primary[800],
  geekBlue: primary[700],
  machoBlue: primary[500],
  lighterMachoBlue: primary[300],
  memeBlue: primary[300],
  rain: primary[300],
  twitter: primary[400],
  facebook: primary[700],
  economicBlue: primary[900],

  // accent / coral family (was tangerine/blush/salmon)
  tangerine: accent[600],
  tangerine0: accent[700],
  tangerine1: accent[500],
  tangerine2: accent[300],
  tangerine3: accent[300],
  tangerine4: accent[100],
  tangerine5: accent[100],
  blush: accent[100],
  salmon: semantic.error.main,
  youthPink: accent[500],
  instagram: accent[600],
  oldschoolOrange: semantic.warning.main,

  // golden-legacy ramp → steel-blue / neutral
  beer0: neutral[900],
  beer1: neutral[900],
  beer2: neutral[900],
  beer3: neutral[900],
  beer4: neutral[900],
  beer5: neutral[400],
  beer6: primary[300],
  beer7: primary[300],
  beer8: primary[400],
  beer9: primary[400],
  beer10: primary[400],
  beer11: primary[400],
  beer12: primary[400],
  beer13: primary[400],
  beer14: primary[400],
  beer15: primary[500],
  beer16: primary[500],
  beer17: primary[500],
  beer19: neutral[800],
  beer20: neutral[800],
  beer21: neutral[850],
  beer22: neutral[900],
  beer23: neutral[900],

  // semantic
  g: semantic.success.main,
  green: semantic.success.main,
  success: semantic.success.main,
  field: semantic.success.main,
  mint: semantic.success.dark,
  mamitaGreen: semantic.success.dark,
  darkGreen: semantic.success.main,
  seeAndBeGreen: semantic.success.dark,
  limeGreen: semantic.success.tint,
  lightLime: semantic.success.tint,
  error: semantic.error.main,
  red: semantic.error.main,
  downHint: semantic.error.main,
  royalred: semantic.error.dark,
  sunshine: semantic.warning.main,
  yellow: semantic.warning.main,
  azure: semantic.info.tint,
  azure1: semantic.info.tint,
  mainstreamBlue: semantic.info.dark,

  // decorative violets → brand chart violet
  lavender: chartPalette[3],
  amethyst: chartPalette[3],
  intellectualLavender: chartPalette[3],
  teenPurple: chartPalette[3],

  // neutrals (warm cream → ink ramp)
  gunmetal: neutral[700],
  black: neutral[950],
  grey: neutral[400],
  warmgray1: neutral[600],
  warmgray2: neutral[500],
  warmgray3: neutral[400],
  warmgray4: neutral[300],
  warmgray5: neutral[200],
  warmgray6: neutral[800],
  coolgray1: neutral[600],
  coolgray2: neutral[500],
  coolgray3: neutral[400],
  coolgray4: neutral[300],
  coolgray5: neutral[100],
  coolgray6: neutral[100],
  coolgray7: neutral[25],
  coolgray8: neutral[700],
  gamerKhaki: neutral[300],
  lightGrey: neutral[50],
  offWhite: neutral[50],
  bone: neutral[50],
  bone1: neutral[25],
  white: neutral[0],
  darkGrey: neutral[800],
  darkerGrey: neutral[950],
  darkMode: neutral[900],
} as const;

// Preserve enum-style type usage (`x: ColorsEnum`) if any caller needs it.
export type ColorsEnum = (typeof ColorsEnum)[keyof typeof ColorsEnum];
